// Rails functionality
import { Turbo } from '@hotwired/turbo-rails'

import { Application } from '@hotwired/stimulus'

// ActionCable Channels
import './channels'

// Stimulus controllers
import './controllers'

require('@rails/activestorage').start()

// Make accessible for Electron and Mobile adapters
window.Turbo = Turbo

import { Slideover } from "tailwindcss-stimulus-components"
import { Modal } from "tailwindcss-stimulus-components"
import { Tabs } from "tailwindcss-stimulus-components"

import Notification from 'stimulus-notification'
import NestedForm from 'stimulus-rails-nested-form'
import TextareaAutogrow from 'stimulus-textarea-autogrow'

const application = Application.start()

application.register('slideover', Slideover)
application.register('modal', Modal)
application.register('notification', Notification)
application.register('tabs', Tabs)
application.register('nested-form', NestedForm)
application.register('textarea-autogrow', TextareaAutogrow)
